"use client";
import {
  Box,
  Heading,
  Stack,
  TableContainer,
  Table,
  Text,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { TABLE_DATA } from "./constants";

const MigrationTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const { heading, tableHeading, tableData } = TABLE_DATA;
  return (
    <Box id="pricing">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        {heading}
      </Heading>
      <TableContainer>
        <Table variant="striped" border={"2px solid rgb(237,242,247)"}>
          <Thead>
            <Tr>
              {tableHeading.map((head, index) => {
                return (
                  <Th key={index} textAlign={"center"} fontWeight={700}>
                    {head}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {tableData.map((data, index) => {
              return (
                <Tr key={index} justifyItems={"center"}>
                  <Td textAlign={"center"} fontWeight={600}>
                    {data.Source}
                  </Td>
                  <Td textAlign={"center"}>{data.Destination}</Td>
                  <Td
                    maxW={{ base: "100%", md: "500px" }}
                    wordBreak="break-word"
                    whiteSpace="normal"
                  >
                    <Stack>
                      {data.Migration_tools.map((tool, index) => (
                        <Box key={index}>
                          <Text as="span" key={index} fontWeight={600} color="text.100">
                            {tool.label} :{" "}
                          </Text>
                          <Text as="span" key={index} color="text.100">
                            {tool.text}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MigrationTable;
